import { render, staticRenderFns } from "./ExampleItinerariesSkeleton.vue?vue&type=template&id=0f5fc769&"
import script from "./ExampleItinerariesSkeleton.vue?vue&type=script&lang=js&"
export * from "./ExampleItinerariesSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ExampleItinerariesSkeleton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports